<template>
  <div class="w-100" :class="{'mb-5':viewtype=='desktop'}">
    <div class="row slim-grid-row mb-4">
      <!-- TITLE -->
      <div :class="is_mobile_view?'col-12 mb-4' : 'col-12 col-lg-2 mb-4 mb-lg-0'">
        <span class="mb-1 d-block body-2">{{$t('hotel.visitor-detail.title')}} <span class="font-weight-bold text-danger">*</span></span>
        <b-dropdown variant="link" class="dd-no-p" no-caret block>
          <template #button-content>
            <div class="w-100 border-form radius-6 p-3 position-relative" :class="{'border-danger': error_form.title != ''}">
              <p class="body-2-1 mb-0">{{ form.title != '' ? $capitalize(form.title) : '--' }}</p>
              <div class="position-absolute" style="top:12px;right:16px;">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.59 0.295013L6 4.87501L1.41 0.295013L0 1.70501L6 7.70501L12 1.70501L10.59 0.295013Z" fill="black" fill-opacity="0.54"/>
                </svg>
              </div>
            </div>
          </template>
          <b-dropdown-item href="#" v-for="(prefix,index) in data_option.title" :key="index" @click="selectPrefix(prefix)">
            <p class="body-2-1 mb-0 py-2">{{ $capitalize(prefix) }}</p>
          </b-dropdown-item>
        </b-dropdown>
        <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.title != ''">{{ error_form.title }}</p>
      </div>

      <!-- FIRST NAME -->
      <div :class="is_mobile_view?'col-6' : 'col-6 col-lg-5'">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.first-name')}} <span class="font-weight-bold text-danger">*</span></label>
          <input
            type="text"
            @input="saveData('first_name')"
            class="p-3 body-2-1 w-100 border-form radius-6"
            :class="{'border-danger': error_form.first_name != ''}"
            placeholder="Alex"
            v-model="form.first_name" >
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.first_name != ''">{{ error_form.first_name }}</p>
        </div>
      </div>

      <!-- LAST NAME -->
      <div :class="is_mobile_view?'col-6' : 'col-6 col-lg-5'">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.last-name')}} <span v-if="getMerchant.booking_engine_last_name == 'REQUIRED'" class="font-weight-bold text-danger">*</span></label>
          <input
            type="text"
            @input="saveData('last_name')"
            class="p-3 body-2-1 w-100 border-form radius-6"
            :class="{'border-danger': error_form.last_name != ''}"
            placeholder="Johnson"
            v-model="form.last_name" >
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.last_name != ''">{{ error_form.last_name }}</p>
        </div>
      </div>
    </div>

    <div class="row slim-grid-row mb-4">
      <!-- COUNTRY -->
      <div v-if="getMerchant.booking_engine_country != 'HIDE'"
        :class="{
          'col-12': (!is_mobile_view && getMerchant.booking_engine_nationality == 'HIDE') || is_mobile_view,
          'col-6': !is_mobile_view && getMerchant.booking_engine_nationality != 'HIDE',
          'mb-4': is_mobile_view && getMerchant.booking_engine_nationality != 'HIDE'
        }">
        <div class="w-100">
          <span class="mb-1 d-block body-2">{{$t('hotel.visitor-detail.country')}} <span v-if="getMerchant.booking_engine_country == 'REQUIRED'" class="font-weight-bold text-danger">*</span></span>
          <v-select
            class="form-select-border body-2-1"
            :class="{'border-danger': error_form.country != ''}"
            label="name"
            :clearable="false"
            @input="saveData('country')"
            :options="data_option.country"
            placeholder="--"
            v-model="form.country">
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            <template #selected-option="{ name }">
              <p class="mb-0 body-2-1 text-truncate">{{ name }}</p>
            </template>
          </v-select>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.country != ''">{{ error_form.country }}</p>
        </div>
      </div>

      <!-- NATIONALITY -->
      <div v-if="getMerchant.booking_engine_nationality != 'HIDE'"
        :class="{
          'col-12': (!is_mobile_view && getMerchant.booking_engine_country == 'HIDE') || is_mobile_view,
          'col-6': !is_mobile_view && getMerchant.booking_engine_country != 'HIDE'
        }">
        <div class="w-100">
          <span class="mb-1 d-block body-2">{{$t('hotel.visitor-detail.nationality')}} <span v-if="getMerchant.booking_engine_nationality == 'REQUIRED'" class="font-weight-bold text-danger">*</span></span>
          <v-select
            class="form-select-border body-2-1"
            :class="{'border-danger': error_form.nationality != ''}"
            label="name"
            :clearable="false"
            @input="saveData('nationality')"
            :options="data_option.country"
            placeholder="--"
            v-model="form.nationality">
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            <template #selected-option="{ name }">
              <p class="mb-0 body-2-1 text-truncate">{{ name }}</p>
            </template>
          </v-select>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.nationality != ''">{{ error_form.nationality }}</p>
        </div>
      </div>
    </div>

    <div class="row slim-grid-row mb-4" v-if="getMerchant.booking_engine_day_of_birth != 'HIDE'">
      <!-- DATE OF BIRTH -->
      <div class="col-12">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.date-of-birth')}} <span v-if="getMerchant.booking_engine_day_of_birth == 'REQUIRED'" class="font-weight-bold text-danger">*</span></label>
          <div class="position-relative">
            <input
              type="text"
              @input="saveData('day_of_birth')"
              data-inputmask="'mask': '99/99/9999','greedy' : false"
              placeholder="DD/MM/YYYY"
              class="p-3 body-2-1 w-100 border-form radius-6"
              :class="{'border-danger': error_form.day_of_birth != ''}"
              v-model="form.day_of_birth" >
            <div class="position-absolute" style="top:12px;right:16px;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="event_24px">
                  <path id="icon/action/event_24px" fill-rule="evenodd" clip-rule="evenodd" d="M18 4H19C20.1 4 21 4.9 21 6V20C21 21.1 20.1 22 19 22H5C3.89001 22 3 21.1 3 20L3.01001 6C3.01001 4.9 3.89001 4 5 4H6V2H8V4H16V2H18V4ZM5 10V20H19V10H5ZM19 8H5V6H19V8ZM17 13H12V18H17V13Z" fill="black" fill-opacity="0.54"/>
                </g>
              </svg>
            </div>
          </div>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.day_of_birth != ''">{{ error_form.day_of_birth }}</p>
        </div>
      </div>
    </div>

    <div class="row slim-grid-row mb-4">
      <!-- EMAIL -->
      <div :class="is_mobile_view?'col-12 mb-4' : 'col-12 col-lg-6 mb-4 mb-lg-0'">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span class="font-weight-bold text-danger">*</span></label>
          <div class="position-relative">
            <input
            type="text"
            @input="saveData('email')"
            class="p-3 body-2-1 w-100 border-form radius-6"
            :class="{'border-danger': error_form.email != ''}"
            placeholder="email@example.com"
            v-model="form.email" >
            <div class="position-absolute" style="top:12px;right:16px;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="local_post_office_24px">
                <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
                </g>
              </svg>
            </div>
          </div>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.email != ''">{{ error_form.email }}</p>
        </div>
      </div>

      <!-- PHONE -->
      <div :class="is_mobile_view ? 'col-12' : 'col-12 col-lg-6'">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span class="font-weight-bold text-danger">*</span></label>
          <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': error_form.phone_number != ''}">
            <div class="row no-gutters">
              <div class="align-self-center" :class="is_mobile_view ? 'col-5' : 'col-4 col-lg-6 col-xl-4'">
                <div class="pr-4 border-r-form" style="padding-block: 4px;" :key="form_key">
                  <v-select
                    class="border-none"
                    :clearable="false"
                    :options="data_option.country"
                    @input="refreshFrom()"
                    label="label"
                    v-model="form.dial_code">
                      <template #search="{ attributes, events }">
                        <input
                          :placeholder="form.dial_code.code ? '' : '+00'"
                          class="vs__search no-focus-border"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>

                      <template #selected-option="{ dial_code }">
                        <p class="mb-0 body-2-1">{{ dial_code }}</p>
                      </template>
                      <template v-slot:option="option">
                        <div class="d-inline-block align-middle mr-2">
                          <country-flag :country='option.code' size='small'/>
                        </div>
                        <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="align-self-center" :class="is_mobile_view ? 'col-7' : 'col-8 col-lg-6 col-xl-8'">
                <input type="number" @input="saveData('phone_number')" class="w-100 border-none no-focus-border body-2-1" placeholder="000 000 000" v-model="form.phone_number" >
              </div>
            </div>
            <div class="position-absolute" style="top:12px;right:16px;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="phone_24px">
                  <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
                </g>
              </svg>
            </div>
          </div>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.phone_number != ''">{{ error_form.phone_number }}</p>
        </div>
      </div>
    </div>

    <div class="w-100">
      <p class="mb-0 body-3-3-1"><span class="font-weight-bold text-danger">* </span>Required field</p>
    </div>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString ,ParseError  } from 'libphonenumber-js'
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import CountryFlag from 'vue-country-flag'
  import moment from 'moment'
  import { validationMixin } from "vuelidate";
  const { required, email,minLength } = require("vuelidate/lib/validators");
  import {
    get
  } from '@/services/index.js'

  export default {
    components:{
      CountryFlag
    },
    props: {
      viewtype:{
        type: String,
        default: 'desktop'
      },
      guest_type:{
        type: String,
        default: 'self' //['self','someone']
      }
    },
    data() {
      return {
        data_option:{
          title: ["MR", "MRS", "MISS", "MS"],
          country: country
        },
        form:{
		      title: '',
          first_name: '',
		      last_name: '',
		      phone_number: '',
		      email: '',
          country: {},
					nationality: {},
          day_of_birth: '',
          dial_code: {}
        },
        error_form:{
          title: '',
          first_name: '',
          last_name: '',
		      phone_number: '',
		      email: '',
          country: '',
					nationality: '',
          day_of_birth: ''
        },
        form_key: 0
      }
    },
    mixins: [validationMixin],
    validations: {
      form:{
        title:{
          required
        },
        first_name:{
          required
        },
        last_name:{
          required
        },
        nationality:{
          required
        },
        day_of_birth:{
          required
        },
        email: {
          required,
          email
        },
        country:{
          required
        },
        phone_number:{
          required
        },
      }
    },
    computed:{
      ...mapGetters([
        'getBeCart',
        'getMerchant'
      ]),
      data(){
				return (this.guest_type == 'self') ? this.getBeCart.customer_details : this.getBeCart.visitor_details
			},
      is_mobile_view(){
        return this.viewtype == 'mobile'
      }
    },
    mounted(){
      this.fillData()
      this.data_option.country = this.data_option.country.map(x=>{
        x.label = `${x.code}/${x.dial_code}`
        return x
      })
      $(document).ready(function(){
        Inputmask().mask(document.querySelectorAll("input"));
      });
    },
    methods:{
      ...mapMutations(['setBeGuestData']),
      selectPrefix(prefix){
        this.form.title = prefix
        this.saveData('title')
      },
      fillData(){
        this.form = Object.assign({}, this.data)
        this.form.dial_code = {}
        this.form.title = this.$isNotEmpty(this.form.title) ? this.data.title.toUpperCase() : ''
        if(this.$isNotEmpty(this.form.country)){
          let country_index = this.data_option.country.findIndex(x=>x.name == this.form.country)
          if(country_index != -1) this.form.country = this.data_option.country[country_index]
          else this.form.country = {}
        }

        if(this.$isNotEmpty(this.form.nationality)){
          let nationality_index = this.data_option.country.findIndex(x=>x.name == this.form.nationality)
          if(nationality_index != -1) this.form.nationality = this.data_option.country[nationality_index]
          else this.form.nationality = {}
        }

        if(this.$isNotEmpty(this.form.day_of_birth)){
          if(this.data.day_of_birth == 'Invalid date'){
            this.setBeGuestData({
              field: 'customer_details',
              data:[
                {key: 'day_of_birth', value: ''}
              ]
            })
            this.form.day_of_birth = ''
          }else{
            let date = moment(this.form.day_of_birth,'YYYY-MM-DD').toDate()
            this.form.day_of_birth = `${moment(date).format("DD")}/${moment(date).format("MM")}/${moment(date).format("YYYY")}`
          }
        }

        this.checkPhoneNumber(this.form.phone_number)
      },
      refreshFrom(){
        this.form_key++
        this.saveData('dial_code')
      },
      checkPhoneNumber(phone_number){
        if(!(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null)){
          try{
            const phone_parsed = parsePhoneNumberFromString(phone_number)
            if (phone_parsed) {
              this.form.dial_code = this.data_option.country.find(x => x.code == phone_parsed.country)
              this.form.phone_number = phone_parsed.nationalNumber
            }else{
              for(let i = 0; i < this.data_option.country.length; i++){
                let el = this.data_option.country[i]
                let check_country = parsePhoneNumber(phone_number,el.code)
                if(check_country.isValid()){
                  this.form.dial_code = this.data_option.country.find(x => x.code == check_country.country)
                  this.form.phone_number = check_country.nationalNumber
                  break;
                }
                if(i+1 == this.data_option.country.length && !check_country.isValid()){
                  console.log("Invalid phone number")
                  this.setBeGuestData({
                    field: 'customer_details',
                    data:[
                      {key: 'phone_number', value: ''}
                    ]
                  })
                  this.form.phone_number = ''
                }
              }
            }
          }catch(err){
            console.log("PHONE NUMBER ERROR :", err.message)
            this.setBeGuestData({
              field: 'customer_details',
              data:[
                {key: 'phone_number', value: ''}
              ]
            })
            this.form.phone_number = ''
          }
        }else{
          this.getDialCodeFromDevice()
        }
      },
      getDialCodeFromDevice(){
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition, showError);
        } else {
          console.log("Geolocation is not supported by this browser.");
        }

        let self = this;
        function showPosition(location_data) {
          let { latitude, longitude } = location_data.coords
          self.parsingArea(latitude, longitude).then((result) => {
            let country = result.address_components.find(x=> x.types.includes('country'))
            let country_code = country.short_name
            self.form.dial_code = self.data_option.country.find(x => x.code == country_code)
            self.form_key++
          }).catch((err) => {
            console.log("ERROR : ", err)
          });
        }

        function showError (error){
          switch(error.code) {
          case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
          case error.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
          case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
        }
        }
      },
      parsingArea(lat,lng){
        return new Promise((success,fail)=>{
          get("CORE","user-location",{
            lat: lat,
            long: lng
          }).then(response=>{
            let res = response.data
            if(res.success){
              success(res.data)
            }else{
              fail(res.message)
            }
          })
        })
      },
      saveData(field){
        let copy_form = this.$deepCopy(this.form)
        let new_value = copy_form[field]

        if(field == 'country' || field == 'nationality') new_value = copy_form[field].name
        if(field == 'day_of_birth') {
          let new_date = moment(copy_form[field],'DD/MM/YYYY').format("YYYY-MM-DD")
          new_value = new_date
        }
        if(field == 'dial_code') {
          new_value =  `${copy_form[field].dial_code}${copy_form.phone_number}`
        }
        if(field == 'phone_number') new_value = `${copy_form.dial_code.dial_code}${copy_form[field]}`

        let params = {
          field: this.guest_type == 'self' ? 'customer_details' : 'visitor_details',
          data: [
            {key: field == 'dial_code' ? 'phone_number' : field, value: new_value}
          ]
        }
        this.setBeGuestData(params)
      },
      resetErrorMessage(){
        this.error_form = {
          title: '',
          first_name: '',
          last_name: '',
		      phone_number: '',
		      email: '',
          country: '',
					nationality: '',
          day_of_birth: ''
        }
      },
      validateForm(){
        return new Promise((success,fail)=>{
          this.resetErrorMessage()
          let form_val = this.$v.form
          if(form_val.title.$invalid){
            this.error_form.title = this.$t('hotel.visitor-detail.title-warning')
          }
          if(form_val.first_name.$invalid){
            this.error_form.first_name = this.$t('hotel.visitor-detail.first-name-warning')
          }
          if(form_val.last_name.$invalid && this.getMerchant.booking_engine_last_name == 'REQUIRED'){
            this.error_form.last_name = this.$t('hotel.visitor-detail.last-name-warning')
          }
          if(form_val.country.$invalid && this.getMerchant.booking_engine_country == 'REQUIRED'){
            this.error_form.country = this.$t('hotel.visitor-detail.country-warning')
          }
          if(form_val.nationality.$invalid && this.getMerchant.booking_engine_nationality == 'REQUIRED'){
            this.error_form.nationality = this.$t('hotel.visitor-detail.nationality-warning')
          }
          if(this.getMerchant.booking_engine_day_of_birth == 'REQUIRED' && (form_val.day_of_birth.$invalid || this.data.day_of_birth == 'Invalid date')){

            this.error_form.day_of_birth = form_val.day_of_birth.$invalid ? this.$t('hotel.visitor-detail.date-of-birth-warning') : this.$t('hotel.visitor-detail.date-of-birth-warning-invalid')
          }
          if(form_val.email.$invalid){
            this.error_form.email = this.$t('hotel.visitor-detail.email-warning')
          }

          let full_pn = `${this.form.dial_code.code}${this.form.phone_number}`
          if(!this.form.dial_code.code){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
          }else if(form_val.phone_number.$invalid){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
          }else if(full_pn.length < 10){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
          }

          let isAllFormValid = () => {
            for(let key in this.error_form){
              if(this.error_form.hasOwnProperty(key) && this.error_form[key] != ''){
                return false
              }
            }
            return true
          }

          if(isAllFormValid()){
            success()
          }else{
            fail()
          }
        })
      }
    }
  }
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number]{
    -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/FormGuestDetail.vue